import { motion } from "framer-motion";

export function PageHeader({ kicker, title, subtitle, testId = "page-header" }) {
  return (
    <section data-testid={testId} className="pt-24 pb-16 radial-bg border-b border-slate-100">
      <div className="container-x">
        {kicker && <div className="kicker mb-6">{kicker}</div>}
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-5xl sm:text-6xl font-serif text-royal-800 tracking-tight leading-[1.05] max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 text-lg text-slate-600 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}

export function Section({ children, className = "", id, testId }) {
  return (
    <section id={id} data-testid={testId} className={`py-20 sm:py-28 ${className}`}>
      <div className="container-x">{children}</div>
    </section>
  );
}

export function DividerGold({ className = "" }) {
  return (
    <div className={`divider-gold ${className}`}>
      <span className="w-1.5 h-1.5 rotate-45 bg-gold" />
    </div>
  );
}
